import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '@abstract/api.service';
import {ErrorLoggerService} from '@services/error-logger.service';
import {CanDeactivate} from '@angular/router';
import {WizardComponent} from '../wizard.component';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {AuthService} from '@services/auth.service';

/**
 * Сервис визарда
 */
@Injectable()
export class WizardService extends ApiService implements CanDeactivate<WizardComponent> {
    protected baseUrl = 'wizard';

    /**
     * Сохранить запись
     *
     * @param options: WizardSaveOptions
     * @return {Observable<any>}
     */
    shadowSave(options: WizardSaveOptions): Observable<any> {
        const {value, sendMail, valid} = options;

        const params = {
            valid: valid || false,
            generate: sendMail || false,
        };

        return this.post({
            dataBody: value,
            queryParams: params
        });
    }

    canDeactivate(wizard) {
        if (!this.authService.isAuthentificated()) {
            return true;
        }
        /**
         * Выполняем фоновое сохранение перед тем, как покинуть страницу визарда
         * @type {boolean}
         */
        return this.shadowSave({
            sendMail: false,
            valid: wizard.form.valid,
            value: wizard.form.getRawValue()
        }).pipe(
            map(() => true),
            catchError(() => of(true))
        );
    }

    constructor(
        http: HttpClient,
        logger: ErrorLoggerService,
        injector: Injector,
        private authService: AuthService,
    ) {
        super(http, logger, injector);
    }
}

interface WizardSaveOptions {
    valid: boolean;
    value: object;
    sendMail?: boolean;
}
